import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PaymentsFormErrorStatesEnum {
    UpdatePaymentFailed = ErrorStateScheduleEnum.PaymentsFormErrorStatesStartIndex,
    UpdateAdjustmentFailed
}
